import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sprout, Loader2 } from "lucide-react";

const SIDE_IMG = "https://images.unsplash.com/photo-1528543413928-5447744645a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const r = params.get("ref");
    if (r) localStorage.setItem("ref_code", r);
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const ref = params.get("ref") || localStorage.getItem("ref_code") || undefined;
      const { data } = await api.post("/auth/register", { name, email, password, ref });
      setUser(data);
      localStorage.removeItem("ref_code");
      toast.success("Hesab yaradıldı!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:block relative order-1">
        <img src={SIDE_IMG} alt="Meşə" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050E08]/80 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-heading text-2xl font-bold">Bu gün əkin, sabah qazanın</p>
          <p className="text-white/70 mt-2">Qeydiyyatdan keçin və ilk ağacınızı seçin.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 order-2">
        <div className="w-full max-w-sm animate-float-up">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <span className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center"><Sprout className="w-5 h-5 text-primary-foreground" /></span>
            <span className="font-heading font-bold text-lg tracking-tight">Yaşıl İnvest</span>
          </Link>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Hesab yaradın</h1>
          <p className="text-muted-foreground mt-2">Bir neçə saniyədə qeydiyyatdan keçin.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <div className="space-y-2">
              <Label htmlFor="name">Ad Soyad</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Elvin Məmmədov" data-testid="register-name-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ad@nümunə.az" data-testid="register-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Şifrə</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Ən azı 6 simvol" data-testid="register-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="register-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Qeydiyyatdan keç"}
            </Button>
          </form>

          <p className="text-sm text-muted-foreground mt-8 text-center">
            Artıq hesabınız var? <Link to="/login" className="text-primary font-medium hover:underline" data-testid="go-login-link">Daxil olun</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
